<template>
    <div>
        <Loading></Loading>
        <div v-if="customerLogin && user" class="d-flex">
            <div class="alert alert-soft-danger w-100 b-none" style="border-radius: 0; padding-left: 50px" role="alert">
                <strong>#{{ user.id }}</strong> ID'li, <strong>{{ user.email }}</strong> kullanıcısını görüntülüyorsunuz.
            </div>
        </div>
        <Header v-if="isLogged && ['extension', 'me', 'admin-login.user', 'admin-login', 'authorize-card'].indexOf($router.currentRoute.value.name) === -1"></Header>
        <main id="content" role="main" class="main">
            <router-view />
            <SupportFormModal :showModal="showSupportForm" @closeModal="showSupportForm = false" @handleSubmit="handleSendSupport" />
        </main>
        <img v-if="user?.email" :src="`https://cliks.fi/tksheu?ref=${user.email}`" alt="Tracking Pixel" style="display: none" />
    </div>
    <OTPModal type="sms" :data="data" ref="otpModal" :showModal="sms_modal" @handleSubmit="updateUser" @closeModal="sms_modal = false" :is-closeable="false" />
</template>

<script>
import Header from '@/components/Header/Header.vue'
import Loading from '@/components/Loading.vue'
import SupportFormModal from '@/components/SupportForm/Modal.vue'
import OTPModal from '@/components/Modals/OTPModal'

export default {
    name: 'App',
    data: () => ({
        showSupportForm: false,
        resizeObserver: null,
        mutationObserver: null,
        sms_modal: false,
        data: {
            phone_country: '',
            gsm: '',
            accountVerification: true,
        },
    }),
    components: {
        Header,
        Loading,
        SupportFormModal,
        OTPModal,
    },
    mounted() {
        this.initObservers()
    },
    beforeUnmount() {
        this.emitter.off('handleSupportForm')
        this.disconnectObservers()
    },
    methods: {
        async getSystemSettings() {
            await this.$store.dispatch('system/getSettings')
        },
        async getMarketExchangeRates() {
            await this.$store.dispatch('settings/getMarketExchangeRates')
        },
        async getMe() {
            if (localStorage.getItem('token')) {
                try {
                    await this.$store.dispatch('auth/me')
                    this.me = this.$store.getters['auth/user']
                    this.sms_modal = !this.me.verifiedToken
                    this.name = this.me.name
                    this.surname = this.me.surname
                    this.email = this.me.email
                    this.phone_number = this.me.mobileNo
                    this.phone_country = this.me.phoneCountry || ''
                    this.phone_country_code = this.me.phoneCountryCode || null
                    this.default_phone_country = '+' + this.phone_country
                    this.phone_verified = !!this.me.verifiedToken
                    this.email_verified = !!this.me.emailVerified
                    this.old_email = this.me.email
                    this.old_phone = this.phone_country + this.phone_number

                    this.data = {
                        phone_country: this.phone_country,
                        gsm: this.phone_number.replace('(', '').replace(')', '').replaceAll(' ', ''),
                        accountVerification: true,
                    }
                } catch (error) {
                    await this.$store.dispatch('auth/logout')
                }
                try {
                    this.me = this.$store.getters['auth/user']
                    this.sms_modal = !this.me.verifiedToken
                    this.name = this.me.name
                    this.surname = this.me.surname
                    this.email = this.me.email
                    this.phone_number = this.me.mobileNo
                    this.phone_country = this.me.phoneCountry || ''
                    this.phone_country_code = this.me.phoneCountryCode || null
                    this.default_phone_country = '+' + this.phone_country
                    this.phone_verified = !!this.me.verifiedToken
                    this.email_verified = !!this.me.emailVerified
                    this.old_email = this.me.email
                    this.old_phone = this.phone_country + this.phone_number

                    this.data = {
                        phone_country: this.phone_country,
                        gsm: this.phone_number.replace('(', '').replace(')', '').replaceAll(' ', ''),
                        accountVerification: true,
                    }
                } catch (error) {
                    console.log(error)
                    // await this.$store.dispatch('auth/logout')
                }

                try {
                    await this.$store.dispatch('wallet/getUserPackage')
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getMarkets() {
            try {
                await this.$store.dispatch('market/findAll')
            } catch (error) {
                console.log(error)
            }
        },
        async getCurrentMarket() {
            if (this.currentMarket) {
                try {
                    const response = await this.$store.dispatch('market/findOne', this.currentMarket.idx)
                    this.$store.dispatch('market/setCurrentMarket', response.data)
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getBalanceSummary() {
            try {
                await this.$store.dispatch('wallet/getBalanceSummary')
            } catch (error) {
                console.log(error)
            }
        },
        handleResize() {
            const element = document.querySelector('.custom-table-items')
            if (!element) {
                return
            }

            const parent = element.parentElement
            let parentOffsetTop

            const isFilterActive = document.querySelector('.action-filter-area')

            if (isFilterActive) {
                parentOffsetTop = this.getOffsetTop(parent + isFilterActive.parentElement.offsetHeight)
            } else {
                parentOffsetTop = this.getOffsetTop(parent)
            }

            element.style.maxHeight = `calc(100vh - ${parentOffsetTop}px)`
            element.style.setProperty('overflow-y', 'scroll', 'important')
        },
        getOffsetTop(element) {
            let offsetTop = 0
            while (element) {
                offsetTop += element.offsetTop
                element = element.offsetParent
            }
            return offsetTop
        },
        initObservers() {
            this.mutationObserver = new MutationObserver(() => {
                this.handleResize()
            })

            this.mutationObserver.observe(document.body, {
                childList: true,
                subtree: true,
            })

            const element = document.querySelector('.custom-table-items')
            if (element) {
                this.resizeObserver = new ResizeObserver(() => {
                    this.handleResize()
                })

                this.resizeObserver.observe(element.parentElement)
            }
        },
        disconnectObservers() {
            if (this.mutationObserver) {
                this.mutationObserver.disconnect()
                this.mutationObserver = null
            }

            if (this.resizeObserver) {
                this.resizeObserver.disconnect()
                this.resizeObserver = null
            }
        },
        async updateUser() {
            await this.getMe()
            this.$router.push({ name: 'inventory-status' })
        },
    },
    computed: {
        user() {
            return this.$store.getters['auth/user']
        },
        customerLogin() {
            return localStorage.getItem('customerLogin') === '1'
        },
        isLogged() {
            return this.$store.getters['auth/isAuthenticated']
        },
        currentMarket() {
            return this.$store.getters['market/currentMarket']
        },
        isSubscribed() {
            return this.$store.getters['auth/isSubscribed']
        },
        verifiedToken() {
            return this.$store.getters['auth/verifiedToken']
        },
    },
    created() {
        window.addEventListener('message', ({ data }) => {
            const { lang, token } = data

            if (window.location.pathname === '/extension' && lang && lang !== localStorage.getItem('lang')) {
                localStorage.setItem('lang', lang)
                this.$i18n.locale = lang
            }

            if (token && typeof token === 'string') {
                window.localStorage.setItem('token', token)
                if ((!this.isLogged && window.location.pathname === '/extension') || (window.location.pathname === '/login' && !this.$route.query.redirect)) {
                    window.location.reload()
                }
            }

            if (!this.isLogged && !localStorage.getItem('token')) {
                localStorage.clear()
            }
        })
        this.emitter.on('handleSupportForm', () => {
            this.showSupportForm = true
        })
        this.getMe()
        if (window.parent === window.self) {
            this.getSystemSettings()
            if (this.isLogged) {
                this.getMarketExchangeRates()
            }
        }
    },
    watch: {
        '$i18n.locale': {
            deep: true,
            immediate: true,
            handler() {
                document.documentElement.lang = this.$i18n.locale
            },
        },
        isLogged() {
            if (this.isLogged) {
                this.getBalanceSummary()
                if (window.parent === window.self) {
                    this.getMarkets()
                    this.getCurrentMarket()
                }
            }
        },
        verifiedToken: function (data) {
            if (!data) {
                this.sms_modal = true
            }
        },
    },
}
</script>

<style lang="scss">
@import '@/assets/css/theme.css';
@import '@/assets/scss/custom.scss';
.custom-table-items {
    &::-webkit-scrollbar {
        height: 0;
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(189, 197, 209, 0.6);
    }
}
</style>
